import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

const Light = () => (
  <svg
    width="320"
    height="320"
    viewBox="0 0 320 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <filter id="rsi-shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="6"/>
        <feOffset dx="0" dy="8" result="o"/>
        <feFlood floodColor="#0F172A" floodOpacity="0.10"/>
        <feComposite in2="o" operator="in"/>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <linearGradient id="rsi-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#EEF2F7"/>
      </linearGradient>
    </defs>
    <g filter="url(#rsi-shadow)">
      <rect x="40" y="80" width="240" height="180" rx="14" fill="url(#rsi-body)"/>
      <rect x="156" y="80" width="6" height="180" fill="#1E3A8A" opacity="0.08"/>
      <g stroke="#94A3B8" strokeOpacity="0.35" strokeWidth="2" strokeLinecap="round">
        <line x1="60" y1="112" x2="142" y2="112"/>
        <line x1="60" y1="128" x2="142" y2="128"/>
        <line x1="60" y1="144" x2="120" y2="144"/>
      </g>
      <rect x="176" y="106" width="86" height="60" rx="4" fill="#1E3A8A" opacity="0.06"/>
      <polyline points="180,158 196,144 212,150 228,128 248,138 262,122"
                stroke="#1E3A8A" strokeOpacity="0.55" strokeWidth="2.5" fill="none"
                strokeLinejoin="round" strokeLinecap="round"/>
      <g fill="#1E3A8A" opacity="0.55">
        <circle cx="196" cy="144" r="2.5"/>
        <circle cx="212" cy="150" r="2.5"/>
        <circle cx="228" cy="128" r="2.5"/>
        <circle cx="248" cy="138" r="2.5"/>
      </g>
      <path d="M180 166 H262 M180 166 V108" stroke="#94A3B8" strokeOpacity="0.45" strokeWidth="1.5"/>
      <g stroke="#94A3B8" strokeOpacity="0.35" strokeWidth="2" strokeLinecap="round">
        <line x1="176" y1="186" x2="262" y2="186"/>
        <line x1="176" y1="202" x2="240" y2="202"/>
        <line x1="176" y1="218" x2="252" y2="218"/>
      </g>
    </g>
    <g filter="url(#rsi-shadow)" transform="translate(228 36)">
      <path d="M14 0 H42 V6 H38 L38 24 L58 56 C62 64 56 72 48 72 H8 C0 72 -6 64 -2 56 L18 24 V6 H14 Z"
            fill="url(#rsi-body)"/>
      <path d="M22 44 L34 44 L50 64 C52 68 50 70 46 70 H10 C6 70 4 68 6 64 Z"
            fill="#2563EB" opacity="0.22"/>
      <circle cx="14" cy="58" r="2" fill="#FFFFFF" opacity="0.9"/>
      <circle cx="40" cy="62" r="1.6" fill="#FFFFFF" opacity="0.8"/>
    </g>
    <g filter="url(#rsi-shadow)" transform="translate(34 240) rotate(-20)">
      <rect x="0" y="0" width="110" height="14" rx="3" fill="url(#rsi-body)"/>
      <rect x="0" y="0" width="22" height="14" rx="3" fill="#1E3A8A" opacity="0.22"/>
      <path d="M110 0 L122 7 L110 14 Z" fill="#1E3A8A" opacity="0.55"/>
      <path d="M120 6 L124 7 L120 8 Z" fill="#0F172A" opacity="0.65"/>
    </g>
  </svg>
);

const Dark = () => (
  <svg
    width="320"
    height="320"
    viewBox="0 0 320 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <filter id="rsi-shadow-d" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="6"/>
        <feOffset dx="0" dy="8" result="o"/>
        <feFlood floodColor="#000000" floodOpacity="0.45"/>
        <feComposite in2="o" operator="in"/>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <linearGradient id="rsi-body-d" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#1F2937"/>
        <stop offset="100%" stopColor="#111827"/>
      </linearGradient>
    </defs>
    <g filter="url(#rsi-shadow-d)">
      <rect x="40" y="80" width="240" height="180" rx="14" fill="url(#rsi-body-d)"/>
      <rect x="156" y="80" width="6" height="180" fill="#60A5FA" opacity="0.18"/>
      <g stroke="#475569" strokeWidth="2" strokeLinecap="round">
        <line x1="60" y1="112" x2="142" y2="112"/>
        <line x1="60" y1="128" x2="142" y2="128"/>
        <line x1="60" y1="144" x2="120" y2="144"/>
      </g>
      <rect x="176" y="106" width="86" height="60" rx="4" fill="#60A5FA" opacity="0.10"/>
      <polyline points="180,158 196,144 212,150 228,128 248,138 262,122"
                stroke="#60A5FA" strokeOpacity="0.75" strokeWidth="2.5" fill="none"
                strokeLinejoin="round" strokeLinecap="round"/>
      <g fill="#60A5FA" opacity="0.75">
        <circle cx="196" cy="144" r="2.5"/>
        <circle cx="212" cy="150" r="2.5"/>
        <circle cx="228" cy="128" r="2.5"/>
        <circle cx="248" cy="138" r="2.5"/>
      </g>
      <path d="M180 166 H262 M180 166 V108" stroke="#475569" strokeWidth="1.5"/>
      <g stroke="#475569" strokeWidth="2" strokeLinecap="round">
        <line x1="176" y1="186" x2="262" y2="186"/>
        <line x1="176" y1="202" x2="240" y2="202"/>
        <line x1="176" y1="218" x2="252" y2="218"/>
      </g>
    </g>
    <g filter="url(#rsi-shadow-d)" transform="translate(228 36)">
      <path d="M14 0 H42 V6 H38 L38 24 L58 56 C62 64 56 72 48 72 H8 C0 72 -6 64 -2 56 L18 24 V6 H14 Z"
            fill="url(#rsi-body-d)"/>
      <path d="M22 44 L34 44 L50 64 C52 68 50 70 46 70 H10 C6 70 4 68 6 64 Z"
            fill="#3B82F6" opacity="0.35"/>
      <circle cx="14" cy="58" r="2" fill="#60A5FA" opacity="0.7"/>
      <circle cx="40" cy="62" r="1.6" fill="#60A5FA" opacity="0.6"/>
    </g>
    <g filter="url(#rsi-shadow-d)" transform="translate(34 240) rotate(-20)">
      <rect x="0" y="0" width="110" height="14" rx="3" fill="url(#rsi-body-d)"/>
      <rect x="0" y="0" width="22" height="14" rx="3" fill="#60A5FA" opacity="0.35"/>
      <path d="M110 0 L122 7 L110 14 Z" fill="#60A5FA" opacity="0.7"/>
      <path d="M120 6 L124 7 L120 8 Z" fill="#94A3B8" opacity="0.9"/>
    </g>
  </svg>
);

export const ResearcherSideIllustration = () => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return <Light />;
  return resolvedTheme === 'dark' ? <Dark /> : <Light />;
};
